import React from 'react';

import {
	ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE,
	LazyTrashedSpacesPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminTrashedSpacesRoute = () => <LazyTrashedSpacesPage />;

AdminTrashedSpacesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
